import React, { Component } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
//import simplWS_client from "./wsService";
import {
  getSystemLatestData,
  ws_getSystemLatestData,
  getSystemIntervalData,
  getSystemInfo,
  getSystemBasics,
  getSystemIDfromHandle,
  getSystem,
} from "../services/systemService";
import { getUserSystems } from "../services/userService";
import { masterCompany } from "../config.json";

import { setJwt } from "../services/httpService";
import { getUser } from "../services/userService";
import "./dashboard.css";
import "../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { getHashCode, setHashCode } from "../services/companyService";
import { get } from "react-scroll/modules/mixins/scroller";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

class FwUpdate extends Component {
  state = {
    productType: "1",
    slaveProductType: "1",
    selectedBackup: null,
  };

  async componentDidMount() {
    const jwt = localStorage.getItem("token");
    setJwt(jwt);
    const user = await getUser();
    try {
      if (user.data.data.company === masterCompany && user.data.data.admin) {
        console.log("master company");
      } else throw "wrong user";
    } catch (err) {
      toast.warning("Error: Must be Simpl Global's Admin...");
    }
    const hashCode = localStorage.getItem("slaveOTA_Hash256");
    if (hashCode) {
      console.log("Hash Code: ", hashCode);
    } else {
      console.log("No Hash Code");
    }
    await this.fetchHashCodeHistory();
  }

  componentWillUnmount() {
    console.log("fw Update CWM");
  }

  handleProductType = ({ currentTarget: input }) => {
    const productType = input.value;
    console.log(productType);
    this.setState({ productType });
  };
  handleSlaveProductType = ({ currentTarget: input }) => {
    const slaveProductType = input.value;
    console.log(slaveProductType);
    this.setState({ slaveProductType });

    // Filter info based on slave product type
    // let filteredHistory;
    // if (slaveProductType === "6") {
    //   filteredHistory = this.state.hashFromDb.filter(
    //     (item) => item.slaveProductType === "6"
    //   );
    // }
    // this.setState({ hashCodeDB: filteredHistory || this.state.hashFromDb });
  };

  fileHandler = (event) => {
    let fileObj = event.target.files[0];
    console.log("File Obj: ", fileObj);
    if (fileObj) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);
        console.log("Array: ", uint8Array);
        var hash = 0;
        const createPromise = new Promise((resolve, reject) => {
          resolve(crypto.subtle.digest("SHA-256", uint8Array));
        });

        createPromise.then((hash) => {
          const uint8ArrayHash = new Uint8Array(hash);

          let str = "";
          for (let i = 0; i < uint8ArrayHash.length; i++) {
            str += uint8ArrayHash[i]
              .toString(16)
              .padStart(2, "0")
              .toUpperCase();
          }
          console.log(str);
          localStorage.setItem("slaveOTA_Hash256", str);
        });
      };
    }
  };

  fileHandlerTestGateway = (event) => {
    let fileObj = event.target.files[0];
    console.log("File Obj: ", fileObj);
    if (fileObj) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);
        console.log("Array: ", uint8Array);
        var hash = 0;
        const createPromise = new Promise((resolve, reject) => {
          resolve(crypto.subtle.digest("SHA-256", uint8Array));
        });

        createPromise.then((hash) => {
          const uint8ArrayHash = new Uint8Array(hash);

          let str = "";
          for (let i = 0; i < uint8ArrayHash.length; i++) {
            str += uint8ArrayHash[i]
              .toString(16)
              .padStart(2, "0")
              .toUpperCase();
          }
          console.log("HashCode ", str);
          localStorage.setItem("slaveOTA_Hash256", str);
          this.setState({ hashCodeGateway: str });

          // const appName = prompt("Please enter the app name:");
          // if (appName !== null) {
          //   console.log("User entered:", appName);
          // } else {
          //   console.log("User cancelled the prompt.");
          //   appName = "Unknown App Name"; // Default value if user cancels
          // }
          // const date = new Date().toLocaleString();
          // const dataJson = {
          //   date: date, // or whatever format you prefer
          //   appName: appName, // replace with your app name variable
          //   hashCode: str, // replace with your actual hash
          // };
          // setHashCode(dataJson);
        });
      };
      this.setState({ selectedFile: event.target.files[0] });
    }
  };

  // For option test in legacy
  fileHandlerTest = (event) => {
    let fileObj = event.target.files[0];
    console.log("File Obj: ", fileObj);
    if (fileObj) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);
        console.log("Array: ", uint8Array);
        var hash = 0;
        const createPromise = new Promise((resolve, reject) => {
          resolve(crypto.subtle.digest("SHA-256", uint8Array));
        });

        createPromise.then((hash) => {
          const uint8ArrayHash = new Uint8Array(hash);

          let str = "";
          for (let i = 0; i < uint8ArrayHash.length; i++) {
            str += uint8ArrayHash[i]
              .toString(16)
              .padStart(2, "0")
              .toUpperCase();
          }
          console.log("HashCode ", str);
          localStorage.setItem("slaveOTA_Hash256", str);
          this.setState({ hashCodeSlave: str });

          // const appName = prompt("Please enter the app name:");
          // if (appName !== null) {
          //   console.log("User entered:", appName);
          // } else {
          //   console.log("User cancelled the prompt.");
          //   appName = "Unknown App Name"; // Default value if user cancels
          // }
          // const date = new Date().toLocaleString();
          // const dataJson = {
          //   date: date, // or whatever format you prefer
          //   appName: appName, // replace with your app name variable
          //   hashCode: str, // replace with your actual hash
          // };
          // setHashCode(dataJson);
        });
      };
      this.setState({ selectedFile: event.target.files[0] });
    }
  };

  handleInputChange2 = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  uploadFwSlave = async (event) => {
    event.preventDefault();

    console.log("Selected file:", this.state.selectedFile);

    if (
      this.state.selectedFile !== null ||
      this.state.selectedFile !== undefined
    ) {
      const formData = new FormData();
      formData.append("firmware_sm_slave_test.bin", this.state.selectedFile);

      try {
        // Upload firmware to backend
        const res = await fetch(
          "http://fwupdate.simplapi.net/fw_sm_slave_test",
          {
            method: "POST",
            body: formData,
          }
        );
        const data = await res.json();
        console.log("Upload response:", data);

        // Update state with the upload response before continuing
        await new Promise((resolve) => {
          this.setState({ firmwareUploadData: data }, resolve);
        });

        // Now save the hash code after firmware data is set
        await this.saveHashCode();

        // Then fetch the updated hash code list from the backend
        await this.fetchHashCodeHistory();

        toast.success("Firmware uploaded successfully!");
      } catch (err) {
        console.error("Upload error:", err);
        toast.error("Firmware upload failed.");
      }
    } else {
      toast.error("Please select a firmware file to upload.");
    }
  };

  uploadFwMaster = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("firmware_sm_slave.bin", this.state.selectedFile);

    try {
      // Upload firmware to backend
      const res = await fetch(
        "https://fwupdate.simplapi.net/fw_sm_slave_test",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      console.log("Upload response:", data);

      // Update state with the upload response before continuing
      await new Promise((resolve) => {
        this.setState({ firmwareUploadData: data }, resolve);
      });

      // Now save the hash code after firmware data is set
      await this.saveHashCodeMaster();

      // Then fetch the updated hash code list from the backend
      await this.fetchHashCodeHistory();

      toast.success("Firmware uploaded successfully!");
    } catch (err) {
      console.error("Upload error:", err);
      toast.error("Firmware upload failed.");
    }
  };

  // This function saves the hash code data into state and to the "DB"
  saveHashCode = async () => {
    let hashCodeHistory = [];

    // Convert whatever's in hashCodeDB into an array
    if (Array.isArray(this.state.hashCodeDB)) {
      hashCodeHistory = [...this.state.hashCodeDB];
    }

    // Build the new hash entry
    const dataJson = {
      date: new Date().toLocaleString(),
      appName: this.state.appName,
      description: this.state.description,
      hashCode: this.state.hashCodeSlave,
      firmwareBackupURL: this.state.firmwareUploadData
        ? this.state.firmwareUploadData.backupFile
        : null,
      slaveProductType: this.state.slaveProductType,
    };

    // Add it to the history
    hashCodeHistory.push(dataJson);

    const data = JSON.stringify(hashCodeHistory);
    console.log("Updated hash code history:", data);

    // Update state
    await new Promise((resolve) => {
      this.setState({ hashCodeDB: hashCodeHistory }, resolve);
    });

    await setHashCode(data);
  };

  saveHashCodeMaster = async () => {
    let hashCodeHistory = [];

    // Convert whatever's in hashCodeDB into an array
    if (Array.isArray(this.state.hashCodeDB)) {
      hashCodeHistory = [...this.state.hashCodeDB];
    }

    // Build the new hash entry
    const dataJson = {
      date: new Date().toLocaleString(),
      appName: this.state.appName,
      description: this.state.description,
      hashCode: this.state.hashCodeGateway,
      firmwareBackupURL: this.state.firmwareUploadData
        ? this.state.firmwareUploadData.backupFile
        : null,
      productType: this.state.productType,
    };

    // Add it to the history
    hashCodeHistory.push(dataJson);

    const data = JSON.stringify(hashCodeHistory);
    console.log("Updated hash code history:", data);

    // Update state
    await new Promise((resolve) => {
      this.setState({ hashCodeDB: hashCodeHistory }, resolve);
    });

    await setHashCode(data);
  };

  // Fetch the updated hash code list from the backend (or storage)
  fetchHashCodeHistory = async () => {
    try {
      const res = await getHashCode();
      const allData = res.data.hashCode;

      this.setState({ hashCodeDB: allData }); // Store the full list

      console.log("Full firmware list:", allData);
    } catch (error) {
      console.error("Error fetching hash code history:", error);
    }
  };

  handleSelectBackup = (backup) => {
    this.setState({ selectedBackup: backup });
    console.log("Selected backup:", backup);
    if (!backup.firmwareBackupURL) {
      console.error("Backup missing firmwareBackupURL:", backup);
      return;
    }
    fetch("http://fwupdate.simplapi.net/selected_fw", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        filename: backup.firmwareBackupURL.split("/").pop(), // just filename
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Server response:", data);
        toast.success("Selected firmware sent successfully!");
      })
      .catch((err) => {
        console.error("Error sending selected firmware:", err);
        toast.error("Error sending selected firmware.");
      });
  };

  handleDeleteFirmware = (firmware) => {
    // Filter out the selected firmware item from the current hashCodeDB array
    const updatedFirmwareList = this.state.hashCodeDB.filter(
      (item) => item !== firmware
    );

    // Update local state with the new list
    this.setState({ hashCodeDB: updatedFirmwareList }, () => {
      // After state is updated, send the new list to your backend via setHashCode
      const dataToSend = JSON.stringify(updatedFirmwareList);

      setHashCode(dataToSend)
        .then((res) => {
          console.log("Updated firmware list sent to server", res.data);
        })
        .catch((err) => {
          console.error("Error updating firmware list on server:", err);
        });
    });
  };

  render() {
    return (
      <>
        <div
          style={{
            width: "350px",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            marginTop: "150px",
            marginBottom: "150px",
            zIndex: 1,
          }}
        >
          <label className="basicParagraph" htmlFor="">
            Select Hub/Master Product Type:
          </label>
          <select
            className="form-control2"
            onChange={this.handleProductType}
            value={this.state.productType}
            style={{ fontSize: "12px", fontWeight: "bold" }}
          >
            <option value="1">Legacy Systems</option>
            <option value="2">SimplHub</option>
            <option value="10">Test Option</option>
            {/*
          <option value="3">Simpl4G</option>
          <option value="4">SimplMeter II</option>
          <option value="5">SimplGateway Hub</option>
          <option value="6">SimplGateway 4G</option>
          <option value="7">SimplMeter II Socket</option>
          <option value="8">SimplATS</option>
          <option value="9">SimplATS 4G</option>
          */}
          </select>
          {this.state.productType === "1" && (
            <form
              action="http://fwupdate.simplapi.net/fw0"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware0.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.productType === "2" && (
            <form
              action="http://fwupdate.simplapi.net/fw_simplhub"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware_simplhub.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.productType === "3" && (
            <form
              action="http://fwupdate.simplapi.net/fw_simpl4g"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware_simpl4g.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.productType === "4" && (
            <form
              action="http://fw-update-dev.us-west-2.elasticbeanstalk.com/fw_sm_ii"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware_sm_ii.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.productType === "5" && (
            <form
              action="http://fwupdate.simplapi.net/fw_sm_ii_hub"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware_sm_ii_hub.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.productType === "6" && (
            <form
              action="http://fwupdate.simplapi.net/fw_sm_ii_4g"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware_sm_ii_4g.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.productType === "7" && (
            <form
              action="http://fwupdate.simplapi.net/fw_sm_socket"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware_sm_socket.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.productType === "8" && (
            <form
              action="http://fwupdate.simplapi.net/fw_simplats"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware_simplats.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.productType === "9" && (
            <form
              action="http://fwupdate.simplapi.net/fw_simplats4g"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{ width: "250px", marginRight: "10px" }}
                name="firmware_simplats4g.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{ marginTop: "10px", width: "150px" }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}

          {this.state.productType === "10" && (
            <>
              <form onSubmit={this.uploadFwMaster.bind(this)}>
                <input
                  type="file"
                  className="inputTariff"
                  style={{
                    width: "250px",
                    marginRight: "10px",
                    backgroundColor: "green",
                  }}
                  name="firmware_sm_slave.bin"
                  onChange={this.fileHandlerTestGateway.bind(this)}
                ></input>
                <input
                  type="submit"
                  className="inputTariff"
                  style={{
                    marginTop: "10px",
                    width: "150px",
                    backgroundColor: "green",
                  }}
                  value="Upload New Firmware"
                ></input>
              </form>
              {this.state.hashCodeGateway && (
                <form
                  onSubmit={this.saveHashCode}
                  style={{
                    maxWidth: "350px",
                    backgroundColor: "#f9fafb",
                    padding: "12px 16px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    margin: "15px auto",
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    fontSize: "0.85rem",
                  }}
                >
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      htmlFor="gatewayAppName"
                      style={{
                        display: "block",
                        fontWeight: "600",
                        marginBottom: "4px",
                        color: "#333",
                      }}
                    >
                      App Name
                    </label>
                    <input
                      type="text"
                      id="gatewayAppName"
                      name="appName"
                      placeholder="Enter app name"
                      onChange={this.handleInputChange2}
                      style={{
                        width: "100%",
                        padding: "6px 8px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        fontSize: "0.85rem",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <label
                      htmlFor="gatewayDescription"
                      style={{
                        display: "block",
                        fontWeight: "600",
                        marginBottom: "4px",
                        color: "#333",
                      }}
                    >
                      Description
                    </label>
                    <input
                      type="text"
                      id="gatewayDescription"
                      name="description"
                      placeholder="Enter description"
                      onChange={this.handleInputChange2}
                      style={{
                        width: "100%",
                        padding: "6px 8px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        fontSize: "0.85rem",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>

                  {/* <button
                    type="submit"
                    style={{
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      transition: "background-color 0.3s ease",
                      width: "100%",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#0056b3")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#007bff")
                    }
                  >
                    Submit
                  </button> */}
                </form>
              )}
            </>
          )}

          <p></p>
          <hr></hr>
          <p></p>
          <label
            className="basicParagraph"
            style={{ color: "green" }}
            htmlFor=""
          >
            Select Subsystem/Slave Product Type:
          </label>
          <select
            className="form-control2"
            onChange={this.handleSlaveProductType}
            value={this.state.slaveProductType}
            style={{ fontSize: "12px", fontWeight: "bold" }}
          >
            <option value="1">Legacy Subsystems</option>
            <option value="2">SimplBox</option>
            {/*<option value="3">SimplNode Subsystem</option>*/}
            <option value="4">SimplNode / SimplMeter II Subsystem</option>
            {/*<option value="5">SimplView</option>*/}
            <option value="6">Test Option</option>
          </select>
          {this.state.slaveProductType === "1" && (
            <form
              action="http://fwupdate.simplapi.net/fw1"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{
                  width: "250px",
                  marginRight: "10px",
                  backgroundColor: "green",
                }}
                name="firmware1.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{
                  marginTop: "10px",
                  width: "150px",
                  backgroundColor: "green",
                }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.slaveProductType === "2" && (
            <form
              action="http://fwupdate.simplapi.net/fw_sbx"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{
                  width: "250px",
                  marginRight: "10px",
                  backgroundColor: "green",
                }}
                name="firmware_sbx.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{
                  marginTop: "10px",
                  width: "150px",
                  backgroundColor: "green",
                }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.slaveProductType === "3" && (
            <form
              action="http://fwupdate.simplapi.net/fw_simplnode"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{
                  width: "250px",
                  marginRight: "10px",
                  backgroundColor: "green",
                }}
                name="firmware_simplnode.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{
                  marginTop: "10px",
                  width: "150px",
                  backgroundColor: "green",
                }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.slaveProductType === "4" && (
            <form
              action="http://fwupdate.simplapi.net/fw_sm_slave"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{
                  width: "250px",
                  marginRight: "10px",
                  backgroundColor: "green",
                }}
                name="firmware_sm_slave.bin"
                onChange={this.fileHandler.bind(this)}
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{
                  marginTop: "10px",
                  width: "150px",
                  backgroundColor: "green",
                }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.slaveProductType === "5" && (
            <form
              action="http://fwupdate.simplapi.net/fw_svu"
              enctype="multipart/form-data"
              method="post"
            >
              <input
                type="file"
                className="inputTariff"
                style={{
                  width: "250px",
                  marginRight: "10px",
                  backgroundColor: "green",
                }}
                name="firmware_svu.bin"
              ></input>
              <input
                type="submit"
                className="inputTariff"
                style={{
                  marginTop: "10px",
                  width: "150px",
                  backgroundColor: "green",
                }}
                value="Upload New Firmware"
              ></input>
            </form>
          )}
          {this.state.slaveProductType === "6" && (
            <>
              <form onSubmit={this.uploadFwSlave.bind(this)}>
                <input
                  type="file"
                  className="inputTariff"
                  style={{
                    width: "250px",
                    marginRight: "10px",
                    backgroundColor: "green",
                  }}
                  name="firmware_sm_slave.bin"
                  onChange={this.fileHandlerTest.bind(this)}
                ></input>
                <input
                  type="submit"
                  className="inputTariff"
                  style={{
                    marginTop: "10px",
                    width: "150px",
                    backgroundColor: "green",
                  }}
                  value="Upload New Firmware"
                  disabled={!this.state.selectedFile}
                ></input>
              </form>

              {this.state.hashCodeSlave && (
                <form
                  onSubmit={this.saveHashCode}
                  style={{
                    maxWidth: "350px",
                    backgroundColor: "#f9fafb",
                    padding: "12px 16px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    margin: "15px auto",
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    fontSize: "0.85rem",
                    marginBottom: "100px",
                  }}
                >
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      htmlFor="appName"
                      style={{
                        display: "block",
                        fontWeight: "600",
                        marginBottom: "4px",
                        color: "#333",
                      }}
                    >
                      App Name
                    </label>
                    <input
                      type="text"
                      id="appName"
                      name="appName"
                      placeholder="Enter app name"
                      onChange={this.handleInputChange}
                      style={{
                        width: "100%",
                        padding: "6px 8px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        fontSize: "0.85rem",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <label
                      htmlFor="description"
                      style={{
                        display: "block",
                        fontWeight: "600",
                        marginBottom: "4px",
                        color: "#333",
                      }}
                    >
                      Description
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      placeholder="Enter a brief description"
                      onChange={this.handleInputChange}
                      rows={3}
                      style={{
                        width: "100%",
                        padding: "6px 8px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        fontSize: "0.85rem",
                        resize: "vertical",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                </form>
              )}
            </>
          )}
        </div>

        {/* Table list of uploaded firmware: */}
        <div
          style={{
            width: "1000px",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            marginTop:
              this.state.hashCodeSlave && this.state.hashCodeGateway
                ? "1100px"
                : this.state.hashCodeSlave || this.state.hashCodeGateway
                ? "800px"
                : "500px",
            marginBottom: "500px",
            zIndex: 1,
          }}
        >
          <label
            className="basicParagraph"
            style={{ color: "green" }}
            htmlFor=""
          >
            Slave History Files
          </label>
          <p></p>
          <table
            className="table"
            style={{ width: "1000px", marginBottom: "50px" }}
          >
            <thead>
              <tr>
                <th>Select</th>
                <th>Date</th>
                <th style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  App Name
                </th>
                <th style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  Description
                </th>
                <th style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  File URL
                </th>
                <th style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(this.state.hashCodeDB) &&
                this.state.hashCodeDB
                  .filter(
                    (fw) =>
                      !this.state.slaveProductType ||
                      fw.slaveProductType === this.state.slaveProductType
                  )
                  .map((fw, index) => (
                    <tr
                      key={index}
                      // style={{
                      //   backgroundColor:
                      //     this.state.selectedBackup?.firmwareBackupURL ===
                      //     fw.firmwareBackupURL
                      //       ? "#e0f7fa"
                      //       : "transparent",
                      // }}
                    >
                      <td>
                        <button
                          onClick={() => this.handleSelectBackup(fw)}
                          disabled={this.state.selectedBackup === fw}
                          style={{
                            padding: "5px 10px",
                            backgroundColor:
                              this.state.selectedBackup === fw
                                ? "gray"
                                : "#007bff",
                            border: "none",
                            color: "white",
                            borderRadius: "4px",
                          }}
                        >
                          {this.state.selectedBackup === fw
                            ? "Selected"
                            : "Select"}
                        </button>
                      </td>
                      <td>{fw.date}</td>
                      <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        {fw.appName}
                      </td>
                      <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        {fw.description}
                      </td>
                      <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        {fw.firmwareBackupURL}
                      </td>
                      <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        <button
                          onClick={() => this.handleDeleteFirmware(fw)}
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            color: "red",
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>

          <label className="basicParagraph" htmlFor="">
            Master History Files
          </label>
          <p></p>
          <table
            className="table"
            style={{ width: "1000px", marginBottom: "150px" }}
          >
            <thead>
              <tr>
                <th>Select</th>
                <th>Date</th>
                <th style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  App Name
                </th>
                <th style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  Description
                </th>
                <th style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  File URL
                </th>
                <th style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(this.state.hashCodeDB) &&
                this.state.hashCodeDB
                  .filter(
                    (fw) =>
                      !this.state.productType ||
                      fw.productType === this.state.productType
                  )
                  .map((fw, index) => (
                    <tr
                      key={index}
                      // style={{
                      //   backgroundColor:
                      //     this.state.selectedBackup?.firmwareBackupURL ===
                      //     fw.firmwareBackupURL
                      //       ? "#e0f7fa"
                      //       : "transparent",
                      // }}
                    >
                      <td>
                        <button
                          onClick={() => this.handleSelectBackup(fw)}
                          disabled={this.state.selectedBackup === fw}
                          style={{
                            padding: "5px 10px",
                            backgroundColor:
                              this.state.selectedBackup === fw
                                ? "gray"
                                : "#007bff",
                            border: "none",
                            color: "white",
                            borderRadius: "4px",
                          }}
                        >
                          {this.state.selectedBackup === fw
                            ? "Selected"
                            : "Select"}
                        </button>
                      </td>
                      <td>{fw.date}</td>
                      <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        {fw.appName}
                      </td>
                      <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        {fw.description}
                      </td>
                      <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        {fw.firmwareBackupURL}
                      </td>
                      <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        <button
                          onClick={() => this.handleDeleteFirmware(fw)}
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            color: "red",
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}
export default FwUpdate;
